import React from 'react';
import { Routes, Route } from "react-router-dom";
import EventAppindex from '../Layout/EventAppindex';
import Home from '../Components/EventApplication/Home';
import CreateProfile from '../Components/EventApplication/CreateProfile';
import BoothDetails from '../Components/EventApplication/BoothDetails';
import UploadArtwork from '../Components/EventApplication/UploadArtwork';
import TermsandConditions from '../Components/EventApplication/TermsandConditions';
import Payment from '../Components/EventApplication/Payment';
import Thanks from '../Components/EventApplication/Thanks';
import EditProfile  from '../Components/EventApplication/EditProfile'; 
import ExhibitorSubscribe from '../Components/EventApplication/ExhibitorSubscribe';

export default function EventAppRoutes(){
    return(
        <Routes >
          <Route element={<EventAppindex/>}>
            <Route path="eventapplication/:id"  element={<Home />} />
            <Route path="createProfile/:id" element={<CreateProfile />} />
            <Route path="boothdetails/:id" element={<BoothDetails />} />
            <Route path="uploadartwork/:id" element={<UploadArtwork />} />
            <Route path="termsandconditions/:id" element={<TermsandConditions />} />
            <Route path="payment/:id" element={<Payment />} />
            <Route path="thanks" element={<Thanks />} />
            <Route path="editexhibitor/:id" element={<EditProfile/>} />
            <Route path="/exhibitor-subscription/:subscription_id" element={<ExhibitorSubscribe />} />
          </Route>
      </Routes>
    )
}